// Premium featured-collection card: wishlist and quick-view were removed
// from the interface (interface simplifiée, style Avril). Add-to-cart is
// handled entirely by Shopify/Dawn's own product-form.js and quick-add.js
// (loaded conditionally by the section), so no custom JS is needed here
// anymore. Kept as an empty file so existing <script> includes across the
// theme keep resolving without a 404.
(function () {
  if (window.__fcpInit) return;
  window.__fcpInit = true;
})();
